import React from 'react';

import Typography from 'kingpin/atoms/Typography';
import InfoIcon from '../../../../../components/InfoIcon';
import Card from '../../../../../components/Common/Card';
import ListItemWrapper from '../../../DatasetDefinitions/ListItemWrapper';
import Column from '../../../DatasetDefinitions/Column';

const TOOLTIP =
  'This metric is used to calculate values in the bonus program data.';

const BonusProgramUsage = ({
  bonusPrograms,
  usedId,
}: {
  bonusPrograms: FleetOps.BonusProgramMetricUsage[];
  usedId: string;
}) => (
  <>
    {bonusPrograms.map((program) => (
      <div key={`${program.programId}-${usedId}`} style={{ marginBottom: 24 }}>
        <div
          style={{
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <Typography.Header type="H5">{program.programName}</Typography.Header>
          <InfoIcon tooltip={TOOLTIP} />
        </div>
        <Card>
          {program.fieldNames.map((fieldName, index) => (
            <ListItemWrapper
              key={`${program.programId}-${fieldName}-${usedId}`}
              isLast={program.fieldNames.length - 1 === index}
            >
              <Column
                style={{
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                }}
              >
                <Typography.Body type="Body 12">{fieldName}</Typography.Body>
              </Column>
            </ListItemWrapper>
          ))}
        </Card>
      </div>
    ))}
  </>
);

export default BonusProgramUsage;
